// extracted by mini-css-extract-plugin
export default {"cls1":"lbJm27kNcjUEY05ZBjWR","cls2":"TM8hFSLqIGhzDL9K9d3s lbJm27kNcjUEY05ZBjWR"};